import $ from 'jquery';

export default function sumoSelect() {
  
  function init() {
    $('.sumoselect').SumoSelect();
  }
  
  if($('.sumoselect').length > 0) {
    $( document ).ready(function() {
      init()
    });
  }
  
}


// WEBPACK FOOTER //
// ./src/assets/js/sumo-select.js